import axios from 'axios';

import { webpack } from '@dr.pogodin/react-utils';

import type { ListResearchLibCategoriesResT } from 'server/controllers/researchLib';
import type * as SSM from 'server/services/researchLib';

import { P_API_RESEARCH_LIB_CATEGORY, type ResearchLibCategoryT } from 'utils';

const ss = webpack.requireWeak<typeof SSM>('server/services/researchLib', import.meta.dirname);

export async function listResearchLibCategories():
Promise<ResearchLibCategoryT[]> {
  if (ss) return ss.listResearchLibCategories();

  const res = await axios<ListResearchLibCategoriesResT>(
    P_API_RESEARCH_LIB_CATEGORY,
  );

  return res.data;
}
